import '@/assets/css/style.m.css'
import '@/assets/css/ui.css'

import Vue from 'vue'
import App from '@/App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

//store
import store from "@/assets/js/store.js";
Vue.prototype.$store = store;

//gid
import gid from "@/assets/js/gid_config.js";
Vue.prototype.$gid = gid;

//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'

//loading
import loading from '@/components/Loading'
Vue.use(loading)

import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
  ops: {
    rail: {
        opacity: 0.6,
        background : '#ba905b',
        size: '6px',
        gutterOfSide : '0px',
    },
    bar: {
        background: '#624520',
        keepShow : true,
        size: '6px',
    }
  }, // 在这里设置全局默认配置
  name: 'vuescroll' // 在这里自定义组件名字，默认是vueScroll
});

//引入样式
//import 'swiper/css/swiper.css'
 
//引入样式
// import style (>= Swiper 6.x)
import 'swiper/dist/css/swiper.min.css'
 
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)

//tips_data
globalThis.tips_data = {};

globalThis.mainApp = null;

import {
  imgsPreloader
} from '@/assets/js/imgPreloader.js';
import imgPreloaderList from '@/assets/js/imgPreloaderList.js';

//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

import GLOBAL from '@/assets/js/global.js'
Vue.prototype.$global = GLOBAL

import BASE64 from '@/assets/js/base64.js'
Vue.prototype.$base64 = BASE64

//ajxa_map
globalThis.ajax_url_map = GLOBAL.ajax_url_map;

//login
import mslogin from '@/assets/js/msLogin.js'
Vue.prototype.$mslogin = mslogin
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login

//FREE
import Free_login from '@/assets/js/freeLogin.js';

// Toast
import Toast from '@/components/Toast'
Vue.prototype.$toast = Toast

//rule
import Rule from '@/components/EvtRule'
Vue.prototype.$rule_modal = Rule

//rank
import Rank_Modal from '@/components/RankRewardModal'
Vue.prototype.$rank_Modal = Rank_Modal

// bind_Modal
import Bind_Modal from '@/components/AreaBind';
Vue.prototype.$bind_modal = Bind_Modal;

// comfirm_Modal
import Comfirm_Modal from '@/components/ComfirmWarn';
Vue.prototype.$comfirm_Modal = Comfirm_Modal;

// success_Modal
import Success_Modal from '@/components/SuccessModal';
Vue.prototype.$success_Modal = Success_Modal;

// success_apply_Modal
import SuccessApply_Modal from '@/components/SuccessApplyModal';
Vue.prototype.$success_Apply = SuccessApply_Modal;

// error_Modal
import Error_Modal from '@/components/ErrorModal';
Vue.prototype.$error_Modal = Error_Modal;

// buy_Modal
import Buy_Modal from '@/components/BuyModal';
Vue.prototype.$buy_Modal = Buy_Modal;

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem)

// item_tips
import Item_Tips from '@/components/ItemTips/itemTips.vue';
Vue.component('item-tips', Item_Tips);
Vue.prototype.$item_tips = function (id, type) {
  mainApp.$refs.app.$refs.tips.visible = true;
  mainApp.$refs.app.$refs.tips.item_id = id;

  let _type = GLOBAL.tipsImg.indexOf(id) > -1 ? 'img' : 'text';
  mainApp.$refs.app.$refs.tips.type = _type;
};

Vue.prototype.$update_ua = function (data) {
  mainApp.ua = data;
};

Vue.prototype.$update_ua_info = function (data) {
  // mainApp.ua.nickName = data.nickName;
  // mainApp.ua.areaId = data.areaId;
  mainApp.$store.commit("$_setUserinfo", data);
};

Vue.prototype.$update_evt = function (data) {
  mainApp.update_evt();
};

(async () => {
  await imgsPreloader(imgPreloaderList);
  //关闭加载弹框
  document.querySelector('.loading').style.display = 'none';
  /* eslint-disable no-new */
  mainApp = new Vue({
    el: '#app',
    components: {
      App
    },
    template: '<App ref="app" :ready="ready" :ua="ua" :evt_info="evt_info" :login="login"/>',
    data() {
      return {
        ua: {},
        evt_info: {},
        code: '',
        name: null,
        login: 0, //登陆
        aid: 0, //大区id
        account_type: 'pc',
        isLoading: false,
        ready: false, //通信阀门            
      }
    },
    created() {
      var _this = this;

      let token = GLOBAL.getQueryVariable('authorization') || localStorage.getItem("token");
      _this.token = token;

      if (token) {
        localStorage.setItem('token', token);
        if (GLOBAL.getQueryVariable('authorization')) {
          window.history.pushState({}, 0, GLOBAL.domain);
        }
      }

      var instance = axios.create();
      instance.defaults.timeout = 1000 * 20;
      axios.defaults.headers.post['Content-Type'] = 'application/json';

      /* 请求拦截 */
      this.$axios.interceptors.request.use(
        config => {

          if (_this.token != null) {
            config.headers["Authorization"] = _this.token;
          }

          if (config.url != ajax_url_map.tips) {
            config.headers["issn"] = GLOBAL.issn;
          }
          this.$loading.show();

          return config;
        },
        err => Promise.reject(err)
      );

      //请求返回拦截
      this.$axios.interceptors.response.use((response) => {
        this.$loading.hide();
        if (response.data.code === 2) {
          //其余错误状态处理
          return Promise.reject(response.data);
        } else if (response.data.code === 401) {
          //未登录
          console.log(response);      
          localStorage.clear();
          _this.token = '';
          _this.$store.commit("$_setLogin", 0);
          _this.$store.commit("$_setUserinfo", {});
          _this.$store.commit("$_setAccount", {});
          _this.$store.commit("$_setTask", []);
          //_this.$mslogin.open();

          return Promise.reject(response.data);
        } else if (response.data.code === 402) {
          //未绑定大区
          //this.$bind_modal();

          return Promise.reject(response.data);
        } else if (response.data.code !== 0) {
          return Promise.reject(response.data);
        }

        return response.data;

      }, function (error) {
        //this.$loading.hide();
        return console.log(error);
      });
    },
    mounted (){
        this.get_user_info();
    
        wx.wxInit({
          title: GLOBAL.wx_share_text.title, // 分享标题
          desc: GLOBAL.wx_share_text.desc, // 分享描述
          link: GLOBAL.domain, // 分享链接
          imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
        });  
    
      },
    methods: {
      get_user_info() {
        // 调用免登录接口，进行免登录验证
        //TODO 梦平台免登录
        let _this = this;

        Free_login.free_login_lazy(
          this.ua.uid, {
            mplat: ajax_url_map.mplat,
            kd: ajax_url_map.free,
          },
          function (response) {
            if (typeof response !== 'undefined') {
              _this.token = response.data ? response.data : response;
            }
            _this.update_evt();

          }
        );
      },
      update_login() {
        let _this = this;

        return new Promise((resolve, reject) => {
          _this.$axios.get(ajax_url_map.logininfo)
            .then(
              res => {
                _this.login = 1;
                _this.ua = res.data;

                _this.$store.commit("$_setLogin", 1);
                _this.$store.commit("$_setUserinfo", res.data);

                resolve(res);
                //_this.update_task ();
              },
              rej => {
                //reject(rej);
                this.ready = true
                _this.update_task ();
              }
            )
            .catch(function (error) {
              console.log(error);
            });
        });

      },
      update_evt() {
        let _this = this;

        async function _evt_init() {
          let _data = await _this.update_login();
          console.log(_data);
          if (!_data.data.areaId) {
            _this.ready = true;
            _this.update_task ();
            return _this.$bind_modal();
          }

          _this.$axios.post(ajax_url_map.userinfo)
            .then(
              res => {
                _this.evt_info = res.data;
                _this.$store.commit("$_setAccount", res.data);
                _this.ready = true;
                _this.update_task ();
              },
              rej => {
                _this.ready = true;
                //_this.update_task ();
              }
            )
        }

        _evt_init();
      },
      update_task (){
        this.$axios.get(ajax_url_map.task)
        .then(
          res => {
            this.$store.commit("$_setTask", res.data);
          },
          rej => {}
        )
      },
    },
  })
})();



// WEBPACK FOOTER //
// ./src/main.js